import { put } from "redux-saga/effects";
import { DocTypes } from "../../common/constants/DocTypes";
import { requestIntakeIntelligenceActionCreator, resetIntakeIntelligenceActionCreator } from "./IntakeDucks";

/**
 * Spec #34100 / F1b-rois — auto-extract-on-attach (AC1/AC2/AC3).
 *
 * On a request-document (DocTypes.REQ) upload, reset the prior analysis (AC2) then run the POST
 * extraction (AC1, requestIntakeIntelligence — replacing the old GET). A non-REQ / append upload
 * (AC3) is a no-op via the recordType gate.
 *
 * Extracted into its own module (imports only put + DocTypes + the intake action creators) so the
 * trigger can be unit-tested in isolation, deliberately avoiding DataEntryDetailsDucks' heavy,
 * node:stream-tainted import chain (services/Network etc.) that prevents that suite from loading.
 */
export function* autoExtractOnRequestUpload(
    recordType: DocTypes | string | undefined,
    organizationId: number,
    requestBufferId: number,
) {
    if (recordType !== DocTypes.REQ) {
        return;
    }
    yield put(resetIntakeIntelligenceActionCreator());
    yield put(requestIntakeIntelligenceActionCreator(organizationId, requestBufferId));
}
